import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { ExtraOptions, Router, RouterModule, Routes } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from './guards/auth-guard.service';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ROUTE_AUTH } from './framework/constants/route.auth.constants';
import { ROUTE_WEBAPP } from './framework/constants/route.webapp.constants';
import { ViewOrDownloadFileComponent } from './pages/webapp/drive/view-or-download-file/view-or-download-file.component';
import { AuthComponent } from './pages/auth/auth.component';
import { BillingRedirectComponent } from './pages/billing/billing-redirect/billing-redirect.component';
import { AdminPanelComponent } from './pages/admin-pannel/admin-panel.component';
import { AdminGuard } from './guards/admin-guard.service';
import { LandingComponent } from './pages/landing/landing.component';

const routes: Routes = [
  {
    path: ROUTE_WEBAPP.BASE,
    loadChildren: () => import(`./pages/webapp/webapp.module`).then((m) => m.WebappModule),
  },
  {
    path: ROUTE_AUTH.BASE,
    resolve: [AuthGuard],
    children: [
      {
        path: '**',
        component: AuthComponent,
      },
    ],
  },
  { path: '', redirectTo: 'landing', pathMatch: 'full' },
  {
    path: 'landing',
    component: LandingComponent,
    resolve: [AuthGuard],
  },
  {
    path: 'admin',
    component: AdminPanelComponent,
    resolve: [AdminGuard],
  },
  {
    path: 'documents/file/:uuid',
    component: ViewOrDownloadFileComponent,
  },
  {
    path: 'billing',
    children: [
      {
        path: '**',
        component: BillingRedirectComponent,
      },
    ],
  },
  { path: '**', component: NotFoundComponent },
  { path: 'not-found', component: NotFoundComponent },
];

const routerOptions: ExtraOptions = {
  anchorScrolling: 'enabled', // Enables anchor scrolling
  scrollPositionRestoration: 'enabled', // Restores scroll position when navigating
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions), BrowserModule, BrowserAnimationsModule],
  exports: [RouterModule],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      // @ts-ignore
      const initializerFn = (() => () => {})(inject(Sentry.TraceService));
      return initializerFn();
    }),
  ],
})
export class AppRoutingModule {}
